export const URL_PROD = 'https://client.orkabit.com/api/v1'
export const URL_QA = 'https://client.qa.orkabit.com/api/v1'
